module.exports = "<div class=\"main\">\n  <router-outlet></router-outlet>\n</div>\n"